import { useState, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { getMap, getView } from './selectors'
import { setMapAndView } from './actions'

const initialState = {
  ready: false,
  classes: {},
}

const getEsri1 = (deps) => {
  return new Promise((resolve, reject) => {
    try {
      window.esriRequire(deps, function () {
        const classes = Array.prototype.slice.call(arguments)
        let result = {}
        deps.forEach((fullClassName, index) => {
          const className = /[^/]*$/.exec(fullClassName)[0]
          result[className] = classes[index]
        })
        resolve(result)
      })
    } catch (exception) {
      console.error('require failed', exception)
      reject(exception)
    }
  })
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

const getEsri = async (deps) => {
  if (typeof window.esriRequire !== 'function') {
    await sleep(100)
    return await getEsri(deps)
  }
  return await getEsri1(deps)
}

export const useEsri = (dependencies) => {
  const [{ ready, classes }, setState] = useState(initialState)

  useEffect(() => {
    if (!ready) {
      getEsri(dependencies).then((classes) => {
        setState({
          ready: true,
          classes,
        })
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dependencies]) // only rerun if dependencies change

  return [ready, classes]
}

export const useMap = () => {
  const dispatch = useDispatch()
  const map = useSelector(getMap)
  const view = useSelector(getView)

  const set = useCallback((map, view) => dispatch(setMapAndView(map, view)), [
    dispatch,
  ])

  return [{ map, view }, set]
}
